<template>
	<div
		:class="[
			`tag align-center border ${colorClasses} ${sizeClasses} ${spacingClasses} ${displayClasses} ${customClass}`
		]"
		@click="$emit('click', $event)"
	>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'b-tag',
	props: {
		/*
		 * Cor da tag.
		 */
		success: Boolean,
		danger: Boolean,
		/*
		 * Delineado ou preenchido.
		 */
		outline: Boolean,
		/*
		 * Tamanho da fonte.
		 */
		tiny: Boolean,
		normal: Boolean,
		big: Boolean,
		xbig: Boolean,
		xxbig: Boolean,
		huge: Boolean,
		xhuge: Boolean,
		/*
		 * Ocupa 100% da largura.
		 */
		block: Boolean,
		/*
		 * Padding padrão.
		 */
		padding: String,
		/*
		 * Padding completo.
		 */
		fullPadding: String,
		/**
		 * Seta a cor da tag, pode ser qualquer cor base disponível no DLS
		 */
		color: String,
		/**
		 * Seta a cor do texto, pode ser qualquer cor base disponível no DLS
		 */
		fontColor: String,
		/**
		 * Seta a cor do background, pode ser qualquer cor base disponível no DLS
		 */
		backgroundColor: String,
		/**
		 * Seta a cor da borda, pode ser qualquer cor base disponível no DLS
		 */
		borderColor: String,
		/**
		 * Classes customizadas
		 */
		customClass: String
	},
	computed: {
		colorClasses() {
			if (this.success && !this.outline) return 'bg-green-base border-green-base white-base';
			if (this.success && this.outline) return 'bg-green-lighter-4 border-green-base';

			if (this.danger && !this.outline) return 'bg-red-base border-red-base white-base';
			if (this.danger && this.outline) return 'bg-red-lighter-4 border-red-base';

			if (this.color && !this.outline)
				return `bg-${this.color}-base border-${this.color}-base white-base`;
			if (this.color && this.outline) return `bg-${this.color}-lighter-4 border-${this.color}-base`;

			let colorClasses = '';

			if (this.fontColor) colorClasses += `${this.fontColor}`;
			if (this.borderColor) colorClasses += ` border-${this.borderColor}`;
			if (this.backgroundColor) colorClasses += ` bg-${this.backgroundColor}`;

			if (colorClasses != '') return colorClasses;

			return 'bg-white-base border-white-darker-4';
		},
		sizeClasses() {
			if (this.tiny) return 'font-size-tiny';
			if (this.normal) return 'font-size-normal';
			if (this.big) return 'font-size-big';
			if (this.xbig) return 'font-size-xbig';
			if (this.xxbig) return 'font-size-xxbig';
			if (this.huge) return 'font-size-huge';
			if (this.xhuge) return 'font-size-xhuge';

			return 'font-size-big';
		},
		spacingClasses() {
			if (this.padding) return `padding-${this.padding}`;

			return 'padding-tiny';
		},
		displayClasses() {
			if (this.block) return 'w100';
			return '';
		}
	}
};
</script>

<style scoped lang="scss">
.tag {
	display: inline-block;
	border-radius: 5px;
}
</style>

<docs>
    Tag
</docs>
